var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBglogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 559,
    viewBox: "0 0 390 559",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.424 526.244L31.2915 528.988L30.9986 502.223L30.5483 502.228L30.1462 424.34L29.2577 343.166L505.413 335.761L505.526 346.072L506.455 430.975L508.633 629.96C508.638 630.399 508.645 631.057 508.65 631.496C508.842 649.047 494.364 663.467 476.352 663.664C458.341 663.862 443.55 649.762 443.358 632.211C443.354 631.772 443.346 631.114 443.342 630.675L443.116 630.677L442.424 526.244ZM95.4697 447.102L441.741 443.312L441.484 419.838L95.2128 423.628L95.4697 447.102ZM312.258 51.5387C298.057 50.1582 282.963 49.4458 267.203 49.6183C183.449 50.535 120.889 74.4776 79.2959 121.449C44.3685 160.229 27.3716 211.977 28.0775 276.477L28.5673 321.232L92.5082 320.532L92.0376 277.532C91.5045 228.828 107.094 192.454 138.797 167.752C168.272 145.049 211.149 133.17 267.435 132.554C283.871 132.375 298.965 133.087 313.171 134.906L312.258 51.5387Z",
    fill: "url(#paint0_linear_4_13)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_13",
    x1: 270.695,
    y1: 665.915,
    x2: 263.951,
    y2: 49.7636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8A719"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 616.298,
    height: 476.721,
    fill: "white",
    transform: "matrix(-0.0109442 -0.99994 -0.99994 0.0109442 470.437 616.261)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBglogo);
export default __webpack_public_path__ + "static/media/bglogo.1f52d7d4988d25d7cc2b976e77c9a165.svg";
export { ForwardRef as ReactComponent };